export const verify_wall_actions = {
  cta_continue: "Continue to app",
  cta_logout: "Sign out",
  logout_aria: "Sign out",
};
